import script from "./packages.vue?vue&type=script&lang=ts&setup=true"
export * from "./packages.vue?vue&type=script&lang=ts&setup=true"

import "./packages.vue?vue&type=style&index=0&id=6a0f32b2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a0f32b2"]])

export default __exports__